export enum ExpressMerchandiseFlags {
  NEXT_STEP,
  SAVE_FORM,
  SUCCESS,
  SHOW_MODAL_LOGIN
}
